import {
    StreamRequestInfo,
    WidgetCustomStreamManager,
    WidgetCustomManagedStreamOptions,
    WidgetStreamByRequestUidConfig,
} from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import {
    getObvStreamRequestInfo,
    getObvStreamRequestInfosForSymbols,
    ObvTileStreamRequest,
} from 'widgets/obvTile/api/ObvTileStreamRequest';
import { WidgetStreamByRequestUidStreamManager } from 'widgets/streaming/widgetStreamManager/WidgetStreamByRequestUidStreamManager';
import State from 'store/State';
import { ObvTileConfigState } from 'widgets/obvTile/store/config/ObvTileConfigState';
import { WidgetId } from 'widgets/WidgetId';
import { DataServices } from 'store/Services';

export const obvTileWidgetStreamConfig: WidgetStreamByRequestUidConfig<ObvTileStreamRequest> =
    {
        channelDestination: 'startObvChartStream',
        managerFactory(
            options: WidgetCustomManagedStreamOptions
        ): WidgetCustomStreamManager {
            return new WidgetStreamByRequestUidStreamManager(options);
        },
        getWidgetStreamRequestInfo(
            state: State,
            services: DataServices,
            id: WidgetId
        ): Promise<StreamRequestInfo<ObvTileStreamRequest> | undefined> {
            return getObvStreamRequestInfo(state, services, id);
        },
        getStreamRequestInfosForSymbols(
            state: State,
            services: DataServices,
            symbols: string[],
            config: unknown
        ): Promise<StreamRequestInfo<ObvTileStreamRequest>[]> {
            return getObvStreamRequestInfosForSymbols(
                state,
                services,
                symbols,
                config as ObvTileConfigState
            );
        },
    };
